import { apiService } from './api';
import {
  Consultancy,
  ConsultancyCreate,
  ConsultancyUpdate,
  PaginationParams,
} from '../types';

export class ConsultanciesService {
  async list(params?: PaginationParams): Promise<Consultancy[]> {
    return apiService.get<Consultancy[]>('/consultancies/', params);
  }

  async getById(id: string): Promise<Consultancy> {
    return apiService.get<Consultancy>(`/consultancies/${id}`);
  }

  async create(data: ConsultancyCreate): Promise<Consultancy> {
    return apiService.post<Consultancy>('/consultancies/', data);
  }

  async update(id: string, data: ConsultancyUpdate): Promise<Consultancy> {
    return apiService.put<Consultancy>(`/consultancies/${id}`, data);
  }

  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`/consultancies/${id}`);
  }
}

export const consultanciesService = new ConsultanciesService();
